import colors from './colors.style';

const foundations = {
  colors,
};

export default foundations;
